import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ScoreboardType } from '../../../../../../enums/scoreboardTypes';
import { selectScoreboardData } from '../../../../../../store/scoreboard/scoreboardSelectors';
import schoolCardImg from '../../../../../../assets/scoreboard/schoolCardImg.png';
import ScoreboardHeaderItem from '../../ScoreboardHeaderItem/ScoreboardHeaderItem';

const SchoolHeaderItem = ({ item, onClick, onMouseEnter, onMouseLeave, isActive }) => {

    const { school } = useSelector((state) => state.auth);
    const { userSchoolHouseId } = useSelector((state) => state.scoreboard);
    const scoreboardDataSelector = useMemo(() => selectScoreboardData(`${ScoreboardType.SCHOOL}_${userSchoolHouseId}`), [userSchoolHouseId]);
    const scoreboardData = useSelector(scoreboardDataSelector);
    const [schoolPosition, setSchoolPosition] = useState(null);

    useEffect(() => {
        const schoolRow = scoreboardData?.rankings?.find(row => row?.schoolId === school?.id);
        if (schoolRow)
            setSchoolPosition(schoolRow?.rank);
    }, [school?.id, scoreboardData, userSchoolHouseId]);

    return (
        <ScoreboardHeaderItem
            image={schoolCardImg}
            number={schoolPosition === 0 ? '--': schoolPosition}
            textKey={item.textKey}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            isActive={isActive}
        />
    );
};

export default SchoolHeaderItem;
